"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Workspaces = void 0;
exports.createIntegration = createIntegration;
const types_1 = require("@air/types");
const request_1 = require("./request");
const util_1 = require("./util");
function switchWorkspaces(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, }) {
        (0, request_1.airRequest)(types_1.EndpointType.workspaces, {
            endpoint: `${workspaceId}/switch`,
        });
    });
}
/**
 *
 * @param input
 * @param input.workspace Arguments for the workspace to create
 * @param input.workspace.sourceId Workspace to clone from (only available in dev)
 * @param input.emails Array of emails to invite to workspace
 * @param input.onboarding Metadata collected in onboarding
 * @param input.onboarding.statedWorkspaceUse What workspace will be used for
 * @param input.onboarding.statedMemberRole Stated occupation of workspace creator
 * @returns Properties of the newly-created workspace
 */
function create(input) {
    return (0, request_1.airRequest)(types_1.EndpointType.workspaces, {
        method: 'POST',
        body: input,
    });
}
function del({ workspaceId }) {
    return (0, request_1.airRequest)(types_1.EndpointType.workspaces, {
        endpoint: workspaceId,
        method: 'DELETE',
    });
}
function createOnboardingData(_a) {
    var { workspaceId } = _a, args = __rest(_a, ["workspaceId"]);
    return (0, request_1.airRequest)(types_1.EndpointType.workspaces, {
        endpoint: `${workspaceId}/createOnboardingData`,
        method: 'POST',
        body: args,
    });
}
/**
 * @returns the workpsace with the given id
 */
function get({ workspaceId }) {
    return (0, request_1.airRequest)(types_1.EndpointType.workspaces, {
        endpoint: `${workspaceId}`,
    });
}
/**
 * List available workspaces
 *
 * @param permissions filter the list of returned workspaces based on a list of required permissions the user must have
 *                    on the workspace
 */
function list({ permissions, } = {}) {
    const perms = permissions
        ? Object.entries(permissions).reduce((acc, [scope, perms]) => {
            Array.prototype.push.apply(acc, Object.entries(perms).reduce((acc, [perm, value]) => {
                if (value) {
                    acc.push(`${scope}.${perm}`);
                }
                return acc;
            }, []));
            return acc;
        }, [])
        : [];
    return (0, request_1.airRequest)(types_1.EndpointType.workspaces, {
        endpoint: perms.length ? `?${(0, util_1.stringifyOptions)({ perms })}` : '',
    });
}
function totals({ workspaceId, }) {
    return (0, request_1.airRequest)(types_1.EndpointType.workspaces, {
        endpoint: `${workspaceId}/totals`,
    });
}
function getRoles({ type, workspaceId, }) {
    const params = type ? `?type=${type}` : '';
    return (0, request_1.airRequest)(types_1.EndpointType.workspaces, {
        endpoint: `${workspaceId}/roles${params}`,
    });
}
/**
 * Update a Workspace
 * @param workspace updates to be made on the Workspace including optional image base64 representation of avatar
 * @returns workspace updates including URL of workspace avatar
 */
function update(_a) {
    var { workspaceId } = _a, input = __rest(_a, ["workspaceId"]);
    return (0, request_1.airRequest)(types_1.EndpointType.workspaces, {
        endpoint: `${workspaceId}/update`,
        method: 'POST',
        body: input,
    });
}
// Invite
function getInvite({ inviteId }) {
    return (0, request_1.airRequest)(types_1.EndpointType.workspaces, {
        endpoint: `join/${inviteId}`,
        authorized: false,
    });
}
/**
 * Returns workspace status and total asset count to be used by initial import
 */
function getWorkspaceImportStatus(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.workspaces, {
            endpoint: `${workspaceId}/importStatus`,
            method: 'GET',
        });
    });
}
function updateAccountWorkspacePositions({ idsToMove, betweenIds, }) {
    return (0, request_1.airRequest)(types_1.EndpointType.workspaces, {
        endpoint: 'position',
        method: 'PATCH',
        body: {
            idsToMove,
            betweenIds,
        },
    });
}
function createInviteToken(_a) {
    return __awaiter(this, arguments, void 0, function* ({ roleId, workspaceId, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.workspaces, {
            method: 'POST',
            endpoint: `${workspaceId}/inviteToken`,
            body: { roleId },
        });
    });
}
function getInviteTokens(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.workspaces, {
            endpoint: `${workspaceId}/inviteToken`,
        });
    });
}
function findInviteToken(_a) {
    return __awaiter(this, arguments, void 0, function* ({ value }) {
        return (0, request_1.airRequest)(types_1.EndpointType.workspaces, {
            endpoint: `inviteToken?${(0, util_1.formatParamsForHttp)({ value })}`,
            authorized: false,
        });
    });
}
function deleteInviteToken(_a) {
    return __awaiter(this, arguments, void 0, function* ({ id, workspaceId, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.workspaces, {
            method: 'DELETE',
            endpoint: `${workspaceId}/inviteToken/${id}`,
        });
    });
}
function listViewFields(_a) {
    return __awaiter(this, arguments, void 0, function* ({ name, workspaceId, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.workspaces, {
            method: 'GET',
            endpoint: `${workspaceId}/viewFields?${(0, util_1.formatParamsForHttp)({
                viewType: name,
            })}`,
        });
    });
}
function getApprovedDomainsSettings(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.workspaces, {
            method: 'GET',
            endpoint: `${workspaceId}/approveddomains`,
        });
    });
}
function updateApprovedDomainsSettings(_a) {
    return __awaiter(this, void 0, void 0, function* () {
        var { workspaceId } = _a, args = __rest(_a, ["workspaceId"]);
        return (0, request_1.airRequest)(types_1.EndpointType.workspaces, {
            method: 'PUT',
            endpoint: `${workspaceId}/approveddomains`,
            body: args,
        });
    });
}
function listIntegrationProviders(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.workspaces, {
            endpoint: `${workspaceId}/integrations/providers`,
        });
    });
}
function listIntegrations(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.workspaces, {
            endpoint: `${workspaceId}/integrations`,
        });
    });
}
function getIntegration(_a) {
    return __awaiter(this, arguments, void 0, function* ({ id, workspaceId, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.workspaces, {
            endpoint: `${workspaceId}/integrations/${id}`,
        });
    });
}
function updateIntegration(_a) {
    return __awaiter(this, arguments, void 0, function* ({ id, update, workspaceId, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.workspaces, {
            endpoint: `${workspaceId}/integrations/${id}`,
            method: 'PATCH',
            body: update,
        });
    });
}
function createIntegration(_a) {
    return __awaiter(this, void 0, void 0, function* () {
        var { workspaceId } = _a, params = __rest(_a, ["workspaceId"]);
        return (0, request_1.airRequest)(types_1.EndpointType.workspaces, {
            endpoint: `${workspaceId}/integrations`,
            method: 'POST',
            body: params,
        });
    });
}
function deleteIntegration(_a) {
    return __awaiter(this, arguments, void 0, function* ({ id, workspaceId, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.workspaces, {
            endpoint: `${workspaceId}/integrations/${id}`,
            method: 'DELETE',
        });
    });
}
exports.Workspaces = {
    switchWorkspaces,
    getWorkspaceImportStatus,
    createInviteToken,
    getInviteTokens,
    findInviteToken,
    deleteInviteToken,
    listViewFields,
    getApprovedDomainsSettings,
    updateApprovedDomainsSettings,
    listIntegrationProviders,
    listIntegrations,
    getIntegration,
    updateIntegration,
    createIntegration,
    deleteIntegration,
    create,
    del,
    createOnboardingData,
    get,
    list,
    totals,
    getRoles,
    update,
    getInvite,
    updateAccountWorkspacePositions,
};
//# sourceMappingURL=workspaces.js.map